'use strict'

import './CreateReview.css'
import React, { useEffect, useState } from 'react'
import ModalDialog from '../../modalDialog/ModalDialog'
import RatingStar from '../ratingStar/RatingStar'
import { axiosConfig, eventEmitter, lang, userId } from '../../../common/baseData'
import axios from 'axios'
import messages from './lang'

function CreateReview (props) {

  const createUrl = '/local/templates/tehnoezh-modern/components/bitrix/blog.post.comment/json/ajax.php'
  const [created, setCreated] = useState(false)
  const [fields, setFields] = useState({
    name: {
      valid: true,
      value: ''
    },
    rating: {
      value: false
    },
    email: {
      valid: true,
      value: ''
    },
    message: {
      valid: true,
      value: ''
    }
  })
  const [show, setShow] = useState(false)

  const uniqueId = props.uniqueId

  useEffect(() => {
    eventEmitter.on(`showForm${uniqueId}`, data => (setShow(true)))
  }, [])

  /**
   * Изменение значения поля
   * @param e
   */
  function onChange (e) {
    switch (e.target.getAttribute('name')) {
      case 'name':
        setFields({ ...fields, name: { value: e.target.value, valid: true} })
        break
      case 'email':
        setFields({ ...fields, email: { value: e.target.value, valid: true} })
        break
      case 'message':
        setFields({ ...fields, message: { value: e.target.value, valid: true} })
        break
      default:
        break
    }
  }

  function onBlur (e) {
      switch (e.target.getAttribute('name')) {
          case 'name':
              setFields({ ...fields, name: { value: fields.name.value, valid: nameValidator(e.target) } })
              break
          case 'email':
              setFields({ ...fields, email: { value: fields.email.value, valid: emailValidator(e.target) } })
              break
          case 'message':
              setFields({ ...fields, message: { value: fields.message.value, valid: textValidator(e.target) } })
              break
          default:
              break
      }
  }

  /**
   * Изменение рейтинга
   * @param e
   */
  function onRatingChange(e) {
    setFields({...fields, rating: {value: e.target.value}})
  }

  function onClose(e) {
    setShow(false)
  }

  /**
   * Сохранение отзыва
   * @param e
   */
  function onSubmit (e) {
    e.preventDefault()

    let formData = new FormData()

    formData.append('action', 'createReview')
    formData.append('postId', props.postId)
    formData.append('blogId', props.blogId)
    formData.append('productId', props.productId)

    // Добавляем данные из формы
    for (let fieldName in fields) {
      if (fields.hasOwnProperty(fieldName) && (fields[fieldName].value.length || parseInt(fields[fieldName].value))) {
        formData.append(fieldName, fields[fieldName].value)
      } else if (fields[fieldName].value === '') {
        fields[fieldName].valid = false;
        setFields({...fields});
      }
    }

    axios.post(createUrl, formData, axiosConfig)
      .then(response => {
        if (response.data.success && response.data.reviewId > 0) setCreated(true)
      })
      .catch(reason => {
        console.log(reason)
      })
  }

  function nameValidator (input) {
      return /^[a-zA-ZА-Яа-яЁёЇїІіЄєҐґ]+([ʼ'-][a-zA-ZА-Яа-яЁёЇїІіЄєҐґ]+)?(\s[a-zA-ZА-Яа-яЁёЇїІіЄєҐґ']+)?$/g.test(input.value)
  }

  function emailValidator (input) {
      return /^([a-zA-Z0-9_.+-])+(\@([a-zA-Z0-9-])+\.)+.+([a-zA-Z0-9])+$/.test(input.value)
  }

  function textValidator (input) {
    return (!(input.value.length <= 0 || input.value.length > 1000))
  }
  
  function getMessage(code) {
    return messages[lang][code] || ''
  }

  /**
   * Формирование звезд
   * @return {*[]}
   */
  const stars = [5, 4, 3, 2, 1].map(i => {
    return <RatingStar key={i} i={i} onChange={onRatingChange}/>
  })

  return (
    <>
      {
        show ?
          <ModalDialog center={false}
                       type="review"
                       opened={true}
                       onClose={onClose}>
            {
              created ?
                <div className="success-send-form" style={{ display: 'block' }}>
                  <div className="row">
                    <div className="modal-title">
                      <span>{getMessage('CPR_REVIEW_THX')}</span>
                    </div>
                  </div>
                  <div className="row">
                    <span>{getMessage('CPR_REVIEW_MODERATE')}</span>
                  </div>
                </div> :
                <form className="form_validate" id="review_form" method="POST">
                  <div className="review-form-content">
                    {
                      userId && Number(userId) > 0 ?
                        <></> :
                        <>
                          <span className="modal-title">{getMessage('CPR_CONTACT_DATA')}</span>
                          <div className="row row-items">
                            <div className={`input-holder field${fields.name.value.length ? ' has-value' : ''}${!fields.name.valid ? ' error' : ''}`}>
                              <input type="text"
                                     className={`input form-control${fields.name.value.length ? ' has-value' : ''}${!fields.name.valid ? ' error' : ''}`}
                                     name="name"
                                     onChange={onChange}
                                     onBlur={onBlur}
                                     value={fields.name.value}/>
                              <span className="label-input">{getMessage('CPR_CONTACT_NAME')}</span>
                              <span className="error-text">{getMessage('COMMENT_DATA_ERROR')}</span>
                            </div>
                            <div className={`input-holder field email${fields.email.value.length ? ' has-value' : ''}${!fields.email.valid ? ' error' : ''}`}>
                              <input type="email"
                                     className={`input form-control${fields.email.value.length ? ' has-value' : ''}${!fields.email.valid ? ' error' : ''}`}
                                     name="email"
                                     onChange={onChange}
                                     onBlur={onBlur}
                                     placeholder="example@gmail.com"
                                     value={fields.email.value}/>
                              <span className="label-input email">{getMessage('CPR_CONTACT_EMAIL')}</span>
                              <span className="error-text">{getMessage('COMMENT_DATA_ERROR')}</span>
                            </div>
                          </div>
                          <div className="row">
                        <span className="modal-subtitle">{getMessage('CPR_CONTACT_OR')}&nbsp;
                          <span className="link-name"
                                data-container="user"
                                data-use="auth" onClick={onClose}>{getMessage('CPR_CONTACT_AUTHORIZE')}</span>
                        </span>
                          </div>
                        </>
                    }
                    <span className="modal-title">{getMessage('CPR_INSERT_REVIEW')}</span>
                    <span className="raiting__title">{getMessage('CPR_YOUR_RATE')}</span>
                    <div className="row raiting__row">
                      <div className="raiting__stars">
                        {stars}
                      </div>
                    </div>
                    <div className="row">
                      <div className={`input-holder field${fields.message.value.length ? ' has-value' : ''}${!fields.message.valid ? ' error' : ''}`}>
                    <textarea className={`input form-control textarea${fields.message.value.length ? ' has-value' : ''}${!fields.message.valid ? ' error' : ''} border-grey-border focus:outline-none focus:ring-0 focus:shadow-none focus:border-grey-border`}
                              name="message"
                              onChange={onChange}
                              onBlur={onBlur}
                              value={fields.message.value}/>
                        <span className="label-input">{getMessage('CPR_REVIEW')}</span>
                      </div>
                    </div>
                    <div className="row submit-holder">
                      <input type="submit" className="btn btn-submit"
                             value={getMessage('CPR_SEND_REVIEW')}
                             onClick={onSubmit}/>
                    </div>
                  </div>
                </form>
            }
          </ModalDialog> :
          <></>
      }
    </>
  )
}

export default CreateReview